<template>
<li>
    <a v-bind:class="{'alpha': !singleAnswer.isAnswered, 'x3': bonusType == 'times_three', 'wildcard': bonusType == 'wild_card','x3-a': multiplier, 'wildcard-a': wildCard }" @click.prevent="handleClick(questionKey)">
        <span class="tag">{{ questionType }}</span>
        <span class="x3"></span>
        <span class="wildcard"></span>

        <p class="pitanje">
        <span>{{ questionKey }}.</span>
        {{ singleAnswer.question }}
        </p>

        <p class="odgovor">
        {{ singleAnswer.isAnswered?'Tvoj odgovor':'Nisi odgovorio/la na ovo pitanje' }}
        <span v-if="singleAnswer.userAnswerValue">{{ singleAnswer.userAnswerValue }}</span>
        <span v-if="singleAnswer.userAnswerImgValue" class="image">{{ singleAnswer.userAnswerImgValue }}</span>
        </p>
    </a>
</li>
</template>

<script>
import { QuestionUtils } from '../utils/questionUtils'
import { BonusType } from '../utils/bonusType'

export default {
    name: 'probna-prijava-pitanja-single',
    props: [ 'questionKey', 'bonusType', 'question', 'setMultiplier', 'setWildCard', 'multiplier', 'wildCard' ],
    data: function () {
        return {
            singleAnswer: {
                isAnswered: false,
                userAnswerImgValue: false,
                userAnswerValue: false,
                question: null
            }
        }
    },
    computed: {
        questionType () {
            return QuestionUtils.getTypeText(this.singleAnswer.type)
        },
        answers () {
            return this.$store.state.exampleRoundAnswers
        }
    },
    methods: {
        handleClick (questionKey) {
            try {
                if (!this.singleAnswer.isAnswered) {
                    return
                }
                switch (this.bonusType) {
                case BonusType.TIMES_THREE:
                    this.setMultiplier(questionKey)
                    break
                case BonusType.WILD_CARD:
                    this.setWildCard(questionKey)
                    break
                }
            } catch (error) {
                console.log(error)
            }
        }
    },
    created () {
        try {
            let answer = this.answers.find((a) => a.questionKey === Number(this.questionKey))

            if (answer.answerIndex != null) {
                this.singleAnswer.isAnswered = true
                this.singleAnswer.userAnswerValue = this.question.answers[answer.answerIndex].value
                this.singleAnswer.userAnswerImgValue = this.question.answers[answer.answerIndex].imgValue
            } else {
                this.singleAnswer.isAnswered = false
            }
        } catch (error) {
            this.singleAnswer.isAnswered = false
        }
        this.singleAnswer.question = this.question.question
        this.singleAnswer.type = this.question.type
    }

}
</script>

<style lang="scss" scoped>
    li {
        margin-bottom: 12px !important;
    }
    a {
        position: relative;
        display: block;
        background-color: #fff;
        border-radius: 6px;
        padding: 50px 12px 11px;
    }
    a.alpha {
        opacity: 0.6;
    }
    a.x3 {
    span.x3 {
        display: block;
    }
    }
    a.wildcard{
        span.wildcard {
            display: block;
        }
    }
    a.x3-a {
        span.x3 {
            display: block;
            background-image: url(~@/assets/img/icons/x3-a.png);
        }
    }
    a.wildcard-a {
        span.wildcard {
            display: block;
            background-image: url(./../assets/background_images/wildcard_on.png);
        }
    }
    a.checked {
        span.check {
            background-image: url(~@/assets/img/icons/checkbox-checked.png);
        }
    }
    .pitanje {
        font-family: "mPlus";
        font-size: 18px;
        line-height: 22px;
        letter-spacing: -.2px;
        color: #000;
        margin-bottom: 24px;

        span {
            color: #3d85ce;
        }
        }
        .odgovor {
        font-family: "axiforma";
        font-weight: 600;
        font-size: 10px;
        color: #737a7f;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin: 0;

        span {
            display: block;
            font-family: "mPlus";
            font-size: 18px;
            line-height: 22px;
            letter-spacing: -.2px;
            color: #000;
            text-transform: none;
        }
    }
    span.tag {
        box-shadow: 0px 9px 10px 0px rgba(255,0,92,0.25);
        background: linear-gradient(135deg, rgba(255,0,132,1) 0%, rgba(255,0,29,1) 100%);
        font-family: "axiforma";
        position: absolute;
        top: 10px;
        left: 14px;
        display: block;
        border-radius: 6px;
        min-width: 50px;
        font-size: 10px;
        text-align: center;
        color: #fff;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 1px;
        padding: 5px 10px 4px;
        background-color: #08305d;
    }
    span.check {
        position: absolute;
        right: 12px;
        top: 10px;
        width: 21px;
        height: 21px;
        background-image: url(~@/assets/img/icons/checkbox.png);
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
    }
    span.x3 {
        position: absolute;
        display: none;
        right: 12px;
        top: 10px;
        width: 21px;
        height: 21px;
        background-image: url(~@/assets/img/icons/x3.png);
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
    }
    span.wildcard {
        position: absolute;
        display: none;
        right: 12px;
        top: 10px;
        width: 21px;
        height: 21px;
        background-image: url(./../assets/background_images/wildcard_off.png);
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
    }
</style>
